export default function handleFloatingRegistrationBtn(){

    const elFloatingBtnWrapper = document.querySelector( '.webinar .fixed-button-wrapper' );

    const elFormWrapper = document.querySelector( '.webinar .form-wrapper' );

    if( !(elFloatingBtnWrapper && elFormWrapper) ) return;

    const elRegisterBtn = elFloatingBtnWrapper.querySelector( 'button' );
    if( elRegisterBtn ){
        elRegisterBtn.addEventListener( 'click', scrollFormIntoView );
    }

    const observer = new IntersectionObserver( handleIntersection, {
        root: null,
        rootMargin: "0px",
        threshold: [0],
    } )
    observer.observe( elFormWrapper );

    function handleIntersection(entries, observer) {
        entries.forEach((entry) => {

            if( adw.webinar_meta?.is_registered === true ){
                elFloatingBtnWrapper.classList.add( 'd-none' );
                return;
            };
            
            if (entry.isIntersecting) {

                if( elFloatingBtnWrapper.classList.contains( 'd-flex' ) ){
                    

                    if( typeof anime === 'function' ){
                        anime( {
                            targets: elFloatingBtnWrapper,
                            opacity: [1, 0],
                            duration: 350,
                            easing: 'easeOutQuad',
                            onComplete: () => {
                                elFloatingBtnWrapper.classList.remove( 'd-flex' );
                                elFloatingBtnWrapper.classList.add( 'd-none' );
                            }
                        } );
                    } else {

                        elFloatingBtnWrapper.classList.remove( 'd-flex' );
                        elFloatingBtnWrapper.classList.add( 'd-none' );

                    }
                } 

            } else {
                if( elFloatingBtnWrapper.classList.contains( 'd-none' ) || elFloatingBtnWrapper.style.opacity < 1 ){
                    elFloatingBtnWrapper.classList.remove( 'd-none' );
                    elFloatingBtnWrapper.classList.add( 'd-flex' );

                    if( typeof anime === 'function' ){
                        anime( {
                            targets: elFloatingBtnWrapper,
                            opacity: [0, 1],
                            duration: 350,
                            easing: 'easeOutQuad',
                        } );
                    }
                }
            }
        });
    };

}

function scrollFormIntoView(){
    $('html, body').animate(
        {
          scrollTop: $('.webinar .form-wrapper').offset().top - 100,
        },
        500,
        'linear'
    )
}